import { Suspense, lazy, useCallback, useMemo, useState } from 'react';

import { sendEvent } from '@spacefill/shared/src/utils/Tagging';
import { useUserContext } from '@spacefill/shared/src/utils/contexts/UserContext';
import { useKeySequence } from '@spacefill/uikit/src/hooks/useKeySequence';

import { DragonEasterEggContext } from './useDragonEasterEgg';

const FlyingDragon = lazy(() =>
    import('@spacefill/uikit/src/components/FlyingDragon').then(
        (module) => ({ default: module.FlyingDragon }),
        () => ({ default: () => null })
    )
);

const DRAGON_KEY_SEQUENCE = [
    'ArrowUp',
    'ArrowDown',
    'ArrowUp',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'ArrowLeft',
    'ArrowRight',
    'b',
    'a',
    'b',
    'a',
];

export const DragonEasterEggProvider = ({ children }) => {
    const { user } = useUserContext();
    const [dragonOrigin, setDragonOrigin] = useState(null);

    const launchDragon = useCallback(
        (origin, trigger) => {
            if (dragonOrigin) {
                return;
            }
            sendEvent('launch-dragon-easter-egg', { trigger, userId: user.id, userEmail: user.email });
            setDragonOrigin(origin);
        },
        [dragonOrigin, user]
    );

    useKeySequence(DRAGON_KEY_SEQUENCE, () => launchDragon({ x: 0, y: window.innerHeight / 2 }, 'konami-code'));

    const value = useMemo(() => ({ launchDragon }), [launchDragon]);

    return (
        <DragonEasterEggContext.Provider value={value}>
            {children}
            {dragonOrigin && (
                <Suspense fallback={null}>
                    <FlyingDragon
                        origin={dragonOrigin}
                        onFinish={() => setDragonOrigin(null)}
                    />
                </Suspense>
            )}
        </DragonEasterEggContext.Provider>
    );
};
